export default __webpack_public_path__ + "static/media/dp2.b203c826.png";